import { ChevronDownIcon } from '@chakra-ui/icons';
import { Hide, IconButton, Image, Show, Skeleton } from '@chakra-ui/react';
import React, { useState } from 'react';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { UserBadge } from 'packages/common-frontend/components/UserBadge';
import mainLogo from 'packages/common-frontend/images/Logo-Horizontal-Normal.svg';
import { Header } from 'packages/header/ui/Header';
import { useSideBarContext } from 'packages/sidebar/hooks/sideBarContext';

export const BorrowerHeader = () => {
  const { toggleSideBar } = useSideBarContext();
  const [logoLoaded, setLogoLoaded] = useState(false);

  const { data, loading } = useGetUserQuery();

  if (loading || !data || !data.user) {
    return <Skeleton />;
  }

  const {
    firstName,
    lastName,
    organization: { name: organizationName },
  } = data.user;

  return (
    <Header
      logoImage={
        <Image
          src={mainLogo}
          alt="Logo"
          width={{ base: '65px', sm: '75px', md: '100px' }}
          cursor="pointer"
          display={logoLoaded ? 'block' : 'none'}
          h="60px"
          onLoad={() => {
            setLogoLoaded(true);
          }}
        />
      }
    >
      <Show above="lg">
        <UserBadge
          userName={`${firstName} ${lastName}`}
          organizationName={organizationName}
        />
      </Show>
      <Hide above="lg">
        <IconButton
          aria-label="View Sidebar"
          icon={<ChevronDownIcon w={8} h={8} />}
          colorscheme="blackAlpha"
          variant="outline"
          onClick={toggleSideBar}
        />
      </Hide>
    </Header>
  );
};
